import React from "react";
import { Col, Form, Input, Modal, Row } from "antd";
import { CreditsLogListParsed } from "../../../../models";
import PaginationLog from "../../Log/PaginationLog";

const defaultSettings = {
  form: {
    amount: {
      label: "Količina",
      field: "amount",
      defaultValue: 1,
      rules: [
        {
          // check if the amount is greater than 0
          validator: (rule, value, callback) => {
            if (!value || value == 0) {
              callback("Unesite količinu");
            } else {
              callback();
            }
          },
          
          required: true,
          message: "Unesite količinu"
        }
      ]
    },
    reason: {
      label: "Razlog",
      field: "reason",
      rowCount: 5,
      rules: [
        {
          min: 4,
          max: 200,
          required: true,
          message: "Unesite razlog"
        }
      ]
    },
    submitButton: {
      text: "Dodaj"
    },
    cancelButton: {
      text: "Odustani"
    }
  },
  modal: {
    title: 'Dodajte kredite korisniku "{0}"'
  }
};

const CreditsForm = (props) => {
  const {
    user,
    form,
    settings,
    show,
    onSubmit,
    onCancel,
    onPageChange,
    log,
    loading
  } = props;

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values);
        form.resetFields();
      }
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  }

  return (
    <Modal
      title={settings.modal.title.replace("{0}", user.email)}
      visible={show}
      onOk={handleSubmit}
      onCancel={handleCancel}
      okText={settings.form.submitButton.text}
      cancelText={settings.form.cancelButton.text}
      width={800}
    >
      <Form>
        <Row gutter={16}>
          <Col span={6}>
            <span className="control-title required">
              {settings.form.amount.label}
            </span>
            <Form.Item>
              {form.getFieldDecorator(settings.form.amount.field, {
                rules: settings.form.amount.rules,
                initialValue: settings.form.amount.defaultValue
              })(
                <Input
                  title={settings.form.amount.label}
                  type="number"
                />
              )}
            </Form.Item>
          </Col>
          <Col span={18}>

            <span className="control-title required">
              {settings.form.reason.label}
            </span>
            <Form.Item>
              {form.getFieldDecorator(settings.form.reason.field, {
                rules: settings.form.reason.rules,
              })(
                <Input
                  type="text"
                  title={settings.form.reason.label}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <PaginationLog
        columns={[
          {
            title: "Datum",
            dataIndex: 'createdAt',
            key: 'createdAt',
          },
          {
            title: "Krediti",
            dataIndex: 'addedBalance',
            key: 'addedBalance',
          },
          {
            title: "Razlog",
            dataIndex: 'reason',
            key: 'reason',
          },
          {
            title: "Dodijelio",
            dataIndex: 'adminEmail',
            key: 'adminEmail',
          },
        ]}
        loading={loading}
        log={log}
        handlePageChange={onPageChange}
        responsiveProps={{
          xs: 24
        }}
        emptyLogText={"Nema loga za prikazat."}
      />
    </Modal>
  );
};

CreditsForm.defaultProps = {
  settings: defaultSettings
};

export default Form.create()(CreditsForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserPage/CreditsForm/CreditsForm.tsx